import { PasswordLoginModel } from '@seahorse/auth';

export class InvitationLoginModel extends PasswordLoginModel {
  invitation?: string;
}
